import React, { Component } from 'react';
import Buttons from '../../../UI/Buttons';


class Status extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
        const {colData,id} = this.props;
        return(
            <td key={"column"+id}>   
                <span className="table_SvgIcon"> 
                { 
                    colData.checked === true ?
                    <i className="fas fa-check text-success fa-lg"></i>
                    : 
                    <i className="fas fa-times text-danger fa-lg"></i>
                }
                </span>
            </td>
        );
    }
}

export default Status;